module.exports = __webpack_public_path__ + "img/aParty_111523_F.5704c111.jpg";